export const isEmptyObject = (obj?: unknown): boolean => {
  if (obj === undefined) {
    return true
  }

  if (obj === null) {
    return false
  }

  if (Array.isArray(obj)) {
    return false
  }

  return Object.keys(obj).length === 0
}
